import React from 'react';

/**
 * MonthHeader is passed an int and renders a corresponding
 * Julian calendar Month abbreviation in a div marked up with
 * a "month" class.
 * @reactProps {int} month - an int from 0-11
 */
export default class MonthHeader extends React.Component {
  /**
   * Given an int from 0-11, returns a Julian month string,
   * i.e. 0 => "Jan", 11 => "Dec", etc.
   * @param {int} num - a number 0-11 that corresponds to a Julian month
   * @return {string} - a string, a Julian month abbreviation
   */
  getMonth(num) {
    switch (num) {
      case 0:
        return 'Jan';
      case 1:
        return 'Feb';
      case 2:
        return 'Mar';
      case 3:
        return 'Apr';
      case 4:
        return 'May';
      case 5:
        return 'Jun';
      case 6:
        return 'Jul';
      case 7:
        return 'Aug';
      case 8:
        return 'Sep';
      case 9:
        return 'Oct';
      case 10:
        return 'Nov';
      case 11:
        return 'Dec';
    }
  }

  /**
   * Get the month and render that string marked up with div
   * @return div - the month string in a div
   */
  render() {
    const month = this.getMonth(this.props.month);
    return <div className="month">{month}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/MonthHeader.js